import { useRef, useEffect } from 'react'

function useDocumentTitle(title: string, prevailOnUnmount = false) {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    // Remove any existing "| FitnFi" suffix before adding the new title
    const cleanTitle = title.replace(/\s*\|\s*FitnFi\s*$/, '');
    document.title = cleanTitle + " | FitnFi";
  }, [title]);

  useEffect(() => () => {
    if (!prevailOnUnmount) {
      // Clean the default title and ensure it doesn't already have the suffix
      const cleanDefaultTitle = defaultTitle.current.replace(/\s*\|\s*FitnFi\s*$/, '');
      document.title = cleanDefaultTitle + " | FitnFi";
    }
  }, [prevailOnUnmount])
}
export default useDocumentTitle